import { useQuery } from '@tanstack/react-query';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useShiftsQuery = () =>
  useQuery({
    queryKey: queryKeys.shifts.list(),
    queryFn: async () => {
      const shifts =
        await ScheduleConfigService.scheduleConfigServiceGetShifts();
      return shifts.data.sort((a, b) => a.rank - b.rank);
    },
  });
